import { render, staticRenderFns } from "./AvatarForum.vue?vue&type=template&id=bdec3100&scoped=true&"
import script from "./AvatarForum.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarForum.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec3100",
  null
  
)

export default component.exports